import useTypingEffect from "./TypingEffect";

const LiveInfoText = ({ textInput }) => {
  const duration = 20;
  const isTypeByLetter = true;
  const textToShow = useTypingEffect(textInput, duration, isTypeByLetter);
  return (
    <section className="dss-welcome-text-section">
      <span className="dss-search-texting">{textToShow}</span>
      <div className="dss-search-texting-end" />
    </section>
  );
};

export default LiveInfoText;
